import { documentDetail } from './document_reducer';

export const document_action = (query) => async (dispatch) => {
    try {
        dispatch(documentDetail(query));
    } catch (err) {
        const error = {
            code: 0,
            message: typeof err == 'object' ? err.message : err,
        };
        throw error;
    }
};
